import type { FaireProductEntity } from "../../entity_types/product";

export const p_fqtneesw33: FaireProductEntity = {
  token: "p_fqtneesw33",
  type: "product",
  name: "Cypress",
  brandToken: "b_ue9948gsud",
  brandName: "Rigaud",
  imageUrl:
    "https://cdn.faire.com/fastly/9443abd26fc1268c28d28a61ede1048fa66fffae7819078f23647482148c89c8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ab46a2b58eef6a8ab52e0b2c33f67de58ceb13d18b952633f33b438246891ac4.png",
    "https://cdn.faire.com/fastly/f303095477d416ef49f377a66661ec46fecc0634139146e8ef6fa3ed59fb58bb.png",
  ],
  priceDollars: 22.5,
  description:
    "Inspired by the richness of the Mediterranean forest. Blending the aromatic sweetness of lavender with the welcoming aroma of cedar wood, Cyprès is timeless, generous and refined.",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:44.960Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
